{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-7-informatik-informationsdarstellung-dateisystem",
  "version": "2026.08.1",
  "title": "Informatik 7: Informationsdarstellung, Binärsystem und Dateisysteme (Realschule 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Informationstechnologie 7: Information vs. Daten, Binärsystem (Dualsystem), Zeichencodierung (ASCII/UTF-8) und hierarchische Dateisysteme.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T22:45:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/7/informationstechnologie",
      "checked": "2026-08-15",
      "label": "Realschule Informationstechnologie 7, Lernbereich Informationsdarstellung und Dateiverwaltung"
    }
  ],
  "atoms": [
    {
      "id": "01K4A7D0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4A7D0000000000000000A01",
      "namespace": "informatik-grundlagen",
      "slug": "information-vs-daten-codierung-kontext",
      "title": "Information versus Daten: Codierung, Interpretation und Syntax/Semantik",
      "domain": "schule/informatik/grundlagen",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q21198",
          "target_label": "Information",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "informationstechnologie",
          "topic_code": "lb1",
          "topic_title": "Informationsdarstellung",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "informationstechnologie",
          "topic_code": "lb1",
          "topic_title": "Informationsdarstellung",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4A7D0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Was unterscheidet 'Information' von reinen 'Daten' in der Informatik?",
          "concept": "Daten sind reine Zeichenfolgen (Syntax); Information entsteht erst durch die Interpretation der Daten in einem bestimmten Kontext (Semantik/Bedeutung)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Information = Daten + Interpretation/Kontext",
              "Daten und Information sind exakt dasselbe"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4A7D0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre das informatische Dreigestirn aus Zeichen/Signal, Daten und Information anhand eines konkreten Praxisbeispiels (z. B. der Zeichenfolge '0815'), definiere den Begriff der Codierung (eindeutige Abbildungsvorschrift nach festen Regeln) und erläutere den Unterschied zwischen Syntax (formale Grammatikregeln) und Semantik (inhaltliche Bedeutung).",
          "concept": "Zeichen/Signal: physikalische Impulse (Bits 0 und 1); Daten: Aneinanderreihung von Zeichen nach syntaktischen Regeln (z. B. '0815'); Information: Bedeutung/Semantik im Kontext (z. B. '08:15 Uhr Unterrichtsbeginn' vs. 'Artikelnummer 0815'); Codierung = eindeutige Übersetzung von Information in Datenstruktur (z. B. Morsecode, ASCII).",
          "sample_solution": "1. Zeichen, Daten und Information im Vergleich: - Zeichen / Signal: Die kleinste physikalische Einheit bzw. diskrete Symbole (z. B. Strom an/aus, 0 und 1, Lichtimpulse). - Daten: Eine strukturierte Aneinanderreihung von Zeichen nach festgelegten formalen Regeln (Syntax), jedoch noch ohne inhaltliche Interpretation (z. B. die reine Zeichenkette '2412'). - Information: Entsteht, wenn Daten in einen interpretierenden Kontext gesetzt werden und dadurch eine Bedeutung (Semantik) für den Empfänger erhalten (z. B. interpretiert als Datum: '24. Dezember – Heiligabend' oder als Geldbetrag '24,12 €'). Formel: **Information = Daten + Kontext / Bedeutung**. 2. Begriff der Codierung: - Codierung ist die nach einer festen Vorschrift (Code) durchgeführte, umkehrbar eindeutige Umwandlung von Informationen (z. B. Text, Zahlen, Bilder) in eine maschinenlesbare Darstellung (Daten / Binärmuster). - Decodierung ist die Rückübersetzung des Codes in die ursprüngliche Information. 3. Syntax vs. Semantik: - Syntax: Das formale Regelsystem (Grammatik, Format, Schreibweise). Ein Fehler in der Syntax ('Syntax Error') führt dazu, dass das System die Zeichenkette nicht verarbeiten kann. - Semantik: Der semantische Gehalt (Sinn und logische Bedeutung). Eine syntaktisch fehlerfreie Zeichenfolge ('Der Stein schläft schnell') kann semantisch sinnlos oder logisch falsch sein."
        }
      ]
    },
    {
      "id": "01K4A7D0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4A7D0000000000000000A02",
      "namespace": "informatik-grundlagen",
      "slug": "binaersystem-dualzahlen-stellenwert-umrechnung",
      "title": "Das Binärsystem (Dualsystem): Stellenwertsystem zur Basis 2 und Umrechnung",
      "domain": "schule/informatik/grundlagen",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4A7D0000000000000000A01",
          "type": "hard",
          "rationale": "Maschinencodierung von Daten basiert auf dem Binärsystem."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q21198",
          "target_label": "Binary number",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "informationstechnologie",
          "topic_code": "lb1",
          "topic_title": "Informationsdarstellung",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "informationstechnologie",
          "topic_code": "lb1",
          "topic_title": "Informationsdarstellung",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4A7D0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Welchen Dezimalwert besitzt die Binärzahl 1011_2?",
          "concept": "11 (1·8 + 0·4 + 1·2 + 1·1 = 11)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "11 (Dezimal)",
              "13 (Dezimal)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4A7D0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Erkläre das Prinzip eines Stellenwertsystems am Vergleich von Dezimalsystem (Basis 10: 10^0, 10^1, 10^2, ...) und Dualsystem / Binärsystem (Basis 2: 2^0=1, 2^1=2, 2^2=4, 2^3=8, 2^4=16, 2^5=32, 2^6=64, 2^7=128), rechne die Dualzahl 110101_2 in das Dezimalsystem um und wandle die Dezimalzahl 43_10 über das Restwertverfahren (wiederholte Division durch 2 mit Rest) in eine Binärzahl um.",
          "concept": "Stellenwert Dualsystem = Potenzen zur Basis 2; 110101_2 = 1*32 + 1*16 + 0*8 + 1*4 + 0*2 + 1*1 = 32 + 16 + 4 + 1 = 53_10; Restwertverfahren für 43: 43:2=21 R1, 21:2=10 R1, 10:2=5 R0, 5:2=2 R1, 2:2=1 R0, 1:2=0 R1 -> von unten nach oben gelesen: 101011_2.",
          "sample_solution": "1. Stellenwertsysteme im Vergleich: - Dezimalsystem (Basis 10): Ziffern 0–9. Stellenwerte sind Zehnerpotenzen: ... 10^3 (1000), 10^2 (100), 10^1 (10), 10^0 (1). - Dualsystem / Binärsystem (Basis 2): Verwendet ausschließlich zwei Ziffern: 0 und 1 (technisch: Strom aus / an). Stellenwerte sind Zweierpotenzen: ... 2^7 (128), 2^6 (64), 2^5 (32), 2^4 (16), 2^3 (8), 2^2 (4), 2^1 (2), 2^0 (1). 2. Umrechnung Dualzahl in Dezimalzahl: Dualzahl: 1 1 0 1 0 1_2 - Berechnung über Stellenwerte: 1 · 2^5 (32) + 1 · 2^4 (16) + 0 · 2^3 (0) + 1 · 2^2 (4) + 0 · 2^1 (0) + 1 · 2^0 (1) = 32 + 16 + 4 + 1 = **53_10**. 3. Umrechnung Dezimalzahl in Dualzahl (Restwert-Divisionsverfahren): Dezimalzahl: 43_10 - 43 : 2 = 21  Rest **1** (niederwertigstes Bit LSB) - 21 : 2 = 10  Rest **1** - 10 : 2 = 5   Rest **0** -  5 : 2 = 2   Rest **1** -  2 : 2 = 1   Rest **0** -  1 : 2 = 0   Rest **1** (höchstwertigstes Bit MSB) - Ergebnis (Reste von unten nach oben gelesen): **43_10 = 101011_2** (Probe: 32 + 8 + 2 + 1 = 43)."
        }
      ]
    },
    {
      "id": "01K4A7D0000000000000000A03",
      "atom_uri": "urn:zam:atom:01K4A7D0000000000000000A03",
      "namespace": "informatik-grundlagen",
      "slug": "textcodierung-ascii-unicode-utf8-speichereinheiten",
      "title": "Textcodierung und Speichereinheiten: Bit, Byte, ASCII und Unicode/UTF-8",
      "domain": "schule/informatik/grundlagen",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4A7D0000000000000000A02",
          "type": "hard",
          "rationale": "Bits und Dualzahlen sind die Einheiten der Zeichentabellen."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q21198",
          "target_label": "Character encoding",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "informationstechnologie",
          "topic_code": "lb1",
          "topic_title": "Informationsdarstellung",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "informationstechnologie",
          "topic_code": "lb1",
          "topic_title": "Informationsdarstellung",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4A7D0000000000000000J05",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Wie viele verschiedene Zustände bzw. Zeichen können mit genau 1 Byte (8 Bit = 2^8) codiert werden?",
          "concept": "Genau 256 verschiedene Zeichen (von 0 bis 255)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "256 Zeichen (2^8)",
              "128 Zeichen (2^7)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4A7D0000000000000000J06",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Definiere die Dateneinheiten Bit, Byte, KiB/KB, MiB/MB, GiB/GB, vergleiche den historischen 7-Bit-ASCII-Code (128 Zeichen, nur englische Schriftzeichen) mit dem modernen Unicode / UTF-8 (variable Byte-Länge, Millionen Schriftzeichen weltweit inkl. Umlaute, Kyrillisch, Arabisch, Emojis) und erkläre, wie der Buchstabe 'A' (ASCII-Dezimalwert 65) als 8-Bit-Binärmuster im Speicher abgelegt wird.",
          "concept": "1 Bit = kleinste Informationseinheit (0/1); 1 Byte = 8 Bit (256 Zustände); Präfixe: 1 KB = 1000 Byte (dezimal) / 1 KiB = 1024 Byte (binär); ASCII = 7 Bit (128 Zeichen, kein ä,ö,ü); UTF-8 = abwärtskompatibel zu ASCII, 1-4 Byte für weltweite Schriftzeichen; 'A' = 65 = 64 + 1 -> Binärmuster 01000001_2.",
          "sample_solution": "1. Speichereinheiten in der Digitaltechnik: - Bit (Binary Digit): Die kleinste unteilbare Informationseinheit im Computer (Wert 0 oder 1). - Byte: Ein Verbund aus genau 8 Bit. Mit 1 Byte lassen sich 2^8 = 256 verschiedene Zustände (Zahlen von 0 bis 255) codieren. - Größere Speichereinheiten:   * 1 Kilobyte (KB) = 1.000 Byte (SI-Norm) bzw. 1 Kibibyte (KiB) = 1.024 Byte (2^10 Byte).   * 1 Megabyte (MB) = 1.000.000 Byte bzw. 1 Mebibyte (MiB) = 1.024 KiB = 1.048.576 Byte.   * 1 Gigabyte (GB) = 1.000 MB bzw. 1 Gibibyte (GiB) = 1.024 MiB. 2. Zeichensätze: ASCII vs. Unicode / UTF-8: - ASCII (American Standard Code for Information Interchange): 7-Bit-Code (2^7 = 128 Zeichen). Enthält nur das lateinische Grundalphabet (A–Z, a–z), Ziffern 0–9, Satzzeichen und Steuerzeichen. Deutsche Umlaute (ä, ö, ü, ß), Akzente oder andere Schriftsysteme fehlen völlig. - Unicode / UTF-8: Universeller weltweiter Standard. UTF-8 verwendet eine variable Codelänge von 1 bis 4 Byte pro Zeichen. Die ersten 128 Zeichen sind 100 % identisch mit ASCII (1 Byte). Umlaute und Sonderzeichen benötigen 2 Byte, asiatische Schriftzeichen und Emojis bis zu 4 Byte. 3. Speicherabbild des Buchstabens 'A': - Dezimalwert in der ASCII-Tabelle: 'A' = 65_10. - Zerlegung in Zweierpotenzen: 65 = 64 + 1 = 1·2^6 + 1·2^0. - 8-Bit-Binärmuster: **01000001**."
        }
      ]
    },
    {
      "id": "01K4A7D0000000000000000A04",
      "atom_uri": "urn:zam:atom:01K4A7D0000000000000000A04",
      "namespace": "informatik-systeme",
      "slug": "dateisystem-baumstruktur-pfade-dateitypen",
      "title": "Hierarchische Dateisysteme: Baumstruktur, absolute/relative Pfade und Dateitypen",
      "domain": "schule/informatik/systeme",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4A7D0000000000000000A01",
          "type": "hard",
          "rationale": "Dateien sind persistente Speicherformen strukturierter Daten."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q21198",
          "target_label": "File system",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "informationstechnologie",
          "topic_code": "lb2",
          "topic_title": "Dateiverwaltung und Organisation",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "informationstechnologie",
          "topic_code": "lb2",
          "topic_title": "Dateiverwaltung und Organisation",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4A7D0000000000000000J07",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Womit beginnt ein 'absoluter Pfad' in einem hierarchischen Dateisystem immer?",
          "concept": "Mit dem Wurzelverzeichnis (Root-Verzeichnis, z. B. '/' unter Linux/macOS oder 'C:\\' unter Windows)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Mit dem Wurzelverzeichnis (Root-Verzeichnis)",
              "Mit dem aktuellen Arbeitsordner"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4A7D0000000000000000J08",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Modelliere ein hierarchisches Dateisystem als Baumstruktur (Wurzel, Ordner/Knoten, Dateien/Blätter), unterscheide absolute Pfade (vom Root-Verzeichnis ausgehend) von relativen Pfaden (vom aktuellen Arbeitsverzeichnis ausgehend unter Nutzung von '.' und '..') und erkläre die Funktion von Dateiendungen (.docx, .pdf, .py, .png) für das Betriebssystem.",
          "concept": "Baumstruktur: Wurzel (Root) ganz oben -> Unterordner (Verzweigungen) -> Dateien (Blätter); Absoluter Pfad: Vollständige Wegbeschreibung ab der Wurzel (z. B. C:\\Schule\\Mathe\\test.pdf); Relativer Pfad: Wegbeschreibung ausgehend vom aktuellen Ordner (z. B. ..\\Bilder\\logo.png, wobei '..' ein Verzeichnis nach oben bedeutet); Dateiendung: Kennzeichnet das Dateiformat und verknüpft die Standardanwendung.",
          "sample_solution": "1. Die Baumstruktur des Dateisystems: - In modernen Betriebssystemen werden Dateien und Verzeichnisse (Ordner) hierarchisch in Form eines umgekehrten Baumes organisiert. - Wurzelverzeichnis (Root): Die oberste Ebene des Dateisystems (z. B. 'C:\\' unter Windows oder '/' unter macOS/Linux). - Knoten (Verzeichnisse / Ordner): Dienen als Behälter zur thematischen Strukturierung weiterer Unterordner oder Dateien. - Blätter (Dateien): Die eigentlichen Nutzdaten-Einheiten am Ende eines Pfades, die keine weiteren Unterelemente enthalten können. 2. Absolute vs. relative Pfadangaben: - Absoluter Pfad: Eindeutige, vollständige Adressierung einer Datei, die immer beim Wurzelverzeichnis (Root) beginnt und unabhängig vom aktuellen Aufenthaltsort des Nutzers gültig ist. Beispiel: `C:\\Benutzer\\Schueler\\Dokumente\\Referat.docx`. - Relativer Pfad: Adressiert eine Datei ausgehend vom derzeit aktiven Arbeitsverzeichnis (Working Directory). Nutzt spezielle Operatoren:   * `.` = das aktuelle Verzeichnis.   * `..` = das übergeordnete Elternverzeichnis (eine Ebene nach oben).   * Beispiel (wenn man sich in `C:\\Benutzer\\Schueler\\Bilder` befindet): `..\\Dokumente\\Referat.docx`. 3. Bedeutung von Dateiendungen (File Extensions): - Dateiendungen (Suffixe nach dem letzten Punkt, z. B. `.txt`, `.pdf`, `.jpg`, `.mp4`, `.py`) signalisieren dem Betriebssystem das interne Speicherformat der Datei. - Das Betriebssystem ordnet über Dateityp-Verknüpfungen automatisch das passende Anwendungsprogramm zum Öffnen und Bearbeiten zu (z. B. `.pdf` mit dem PDF-Viewer, `.docx` mit dem Textverarbeitungsprogramm)."
        }
      ]
    }
  ]
}
